// src/App.jsx
import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from 'react-router-dom';

// Components
import Navbar from './Components/Navbar';
import Footer from './Pages/Footer';

// Pages
import LandingPage from './Pages/LandingPage';
import Home from './Pages/Home';
import About from './Pages/About';
import Services from './Pages/Services';
import Contact from './Pages/Contact';
import CoreValue from './Pages/CoreValue';
import OurMission from './Pages/OurMission';
import Vision from './Pages/Vision';
import Leaders from './Pages/Leaders';
import CeoVision from './Pages/CeoVision';

import Utility from './Pages/Utility';
import Transportation from './Pages/Transportation';
import Healthcare from './Pages/Healthcare';
import Engineering from './Pages/Engineering';
import Telecom from './Pages/Telecom';

import InovaantageClicks from './Pages/InovaantageClicks';
import PressRelease from './Pages/PressRelease';

import Careers from './Pages/Careers';
import Jobopening from './Pages/Jobopening';
import Lifeatinovaantage from './Pages/Lifeatinovaantage';
import Offices from './Pages/Offices';
import InovaantagePosters from './Pages/InovaantagePosters';

// Tools/Products Pages (renamed/fixed)
import Carretera from './Pages/Carretera';
import DataMigrationTool from './Pages/DataMigrationTool';
import Conductpro from './Pages/Conductpro';


// 🔁 This hook forces redirect to LandingPage on page reload
function ReloadRedirectToLanding() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const hasReloaded = sessionStorage.getItem('hasReloaded');
    if (!hasReloaded) {
      sessionStorage.setItem('hasReloaded', 'true');
      if (location.pathname !== '/') {
        navigate('/', { replace: true });
      }
    }
  }, [location.pathname, navigate]);

  return null;
}

function App() {
  return (
    <Router>
      <Navbar />
      <div className="container mt-4">
        <ReloadRedirectToLanding />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/about/utilities" element={<Utility />} />
          <Route path="/about/transportation" element={<Transportation />} />
          <Route path="/about/healthcare" element={<Healthcare />} />
          <Route path="/about/engineering" element={<Engineering />} />
          <Route path="/about/telecom" element={<Telecom />} />

          <Route path="/services" element={<Services />} />
          <Route path="/services/conductpro" element={<Conductpro />} />

          <Route path="/contact" element={<Contact />} />
          <Route path="/contact/offices" element={<Offices />} />
          <Route path="/contact/lifeatinovaantage" element={<Lifeatinovaantage />} />
          <Route path="/contact/carretera" element={<Carretera />} />
          <Route path="/contact/datamigrationtool" element={<DataMigrationTool />} />
          <Route path="/contact/conductpro" element={<Conductpro />} />

          <Route path="/careers" element={<Careers />} />
          <Route path="/jobopening" element={<Jobopening />} />

          <Route path="/core-value" element={<CoreValue />} />
          <Route path="/our-mission" element={<OurMission />} />
          <Route path="/vision" element={<Vision />} />
          <Route path="/leaders" element={<Leaders />} />
          <Route path="/ceo-vision" element={<CeoVision />} />

          <Route path="/inovaantageClicks" element={<InovaantageClicks />} />
          <Route path="/gallery/inovaantageposters" element={<InovaantagePosters />} />
          <Route path="/gallery/pressrelease" element={<PressRelease />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
